import { useDispatch } from "react-redux";

const useHandlePageChange = (setGridState, setCurrentPage) => {
  const dispatch = useDispatch();

  return (params) => {
    if (params.nativeEvent.type === "input") {
      return;
    }

    const pageNumber = Math.floor(params.page.skip / params.page.take) + 1;
    dispatch(setCurrentPage(pageNumber));
    const pageSize = params.page.take;

    setGridState((prevState) => ({
      ...prevState,
      pageNumber,
      pageSize,
    }));
  };
};

export default useHandlePageChange;
